import { jsonb, pgTable } from 'drizzle-orm/pg-core';
import { tableBase } from '../../utils';
import { IntegrationPartner } from '../../enums';
export const eliteFormTrackerClassification = [
    'Not Tracked',
    'Barbell Unspecified',
    'Bench Press',
    'Hang Clean',
    'Squat',
    'Squat Jump',
    'Overhead Jerk',
    'Incline Bench Press',
    'High Pull',
    'Front Squat',
    'Squat (Down Camera)',
    'Hang Snatch',
    'Video Only',
    'Overhead Squat',
    'Trap Bar Jump Shrug',
    'Trap Bar Unspecified',
    'Power Clean',
    'Barbell Deadlift',
    'Trap Bar Deadlift',
];
export const IntegrationProviders = pgTable('integration_providers', {
    ...tableBase,
    integrationProvider: IntegrationPartner('integration_provider'),
    integrationProperties: jsonb('integration_properties')
        .$type()
        .default({}),
});
//# sourceMappingURL=integration-providers.js.map